import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=3ac8cc81&scoped=true&"
import script from "./CommonForm.vue?vue&type=script&lang=ts&"
export * from "./CommonForm.vue?vue&type=script&lang=ts&"
import style0 from "./CommonForm.vue?vue&type=style&index=0&id=3ac8cc81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac8cc81",
  null
  
)

export default component.exports